var moment = require('moment');
var crypto = require('crypto');

angular.module("imagenet")
    .factory('AuthInterceptor', ["TokenLibrary", "$q", "API_URL", "$cookies", function (TokenLibrary, $q, API_URL, $cookies) {
        'use strict';

        var requestInterceptor = function(req) {
            req.headers = req.headers || {};
            var defer = $q.defer();

            if(req.url.indexOf('https://s3.eu-central-1.amazonaws.com') > -1) {
                //console.log("aws req: " + req.url);
                TokenLibrary.getLib('aws').then(function (token) {
                    defer.resolve(awsV4Sign(req, token));
                });
            } else if (req.url.indexOf(API_URL + '/api/auth/register') > -1 || req.url.indexOf(API_URL + '/api/auth/login') > -1 || req.url.indexOf(API_URL + '/api/auth/setpassword') > -1 || req.url.indexOf(API_URL + '/api/auth/forgotpassword') > -1){
                defer.resolve(req);
            } else if (req.url.indexOf(API_URL + '/api/auth/token') > -1){
                //console.log("refresh token req: " + req.url);
                req.headers.Authorization = 'Bearer ' + TokenLibrary.getRefreshToken();
                defer.resolve(req);
            } else if (req.url.indexOf(API_URL + '/api') > -1 || req.url.indexOf(API_URL + '/download') > -1){
                //console.log("api req: " + req.url);
                TokenLibrary.getLib('accessToken').then(function (token) {
                    req.headers.Authorization = 'Bearer ' + token;
                    defer.resolve(req);
                });
            } else {
                defer.resolve(req);
            }

            return defer.promise;
        };

        var awsV4Sign = function (req, credentials) {

            var url = req.url.replace('https://s3.eu-central-1.amazonaws.com','').split("?");
            var canonicalUrl = url[0];
            var canonicalQs = url[1] || "";
            var now = moment().utc().format("YYYYMMDDTHHmmss[Z]");
            var today = moment().utc().format("YYYYMMDD");

            var canonicalRequest = "GET\n"+
                canonicalUrl+"\n"+
                canonicalQs+"\n"+
                "host:s3.eu-central-1.amazonaws.com\n"+
                "x-amz-content-sha256:"+crypto.createHash('sha256').update('').digest('hex')+"\n"+
                "x-amz-date:"+now+"\n"+
                "x-amz-security-token:"+ credentials.sessionToken + "\n"+
                "\n"+
                "host;x-amz-content-sha256;x-amz-date;x-amz-security-token\n"+
                crypto.createHash('sha256').update('').digest('hex');

            var stringToSign = "AWS4-HMAC-SHA256\n" +
                now + "\n" +
                today + "/eu-central-1/s3/aws4_request\n" +
                crypto.createHash('sha256').update(canonicalRequest).digest('hex');

            var Signature = crypto.createHmac('sha256', new Buffer(credentials.signingKey, 'base64')).update(stringToSign).digest('hex');

            var Authorization = "AWS4-HMAC-SHA256 Credential="+credentials.accessKeyId+"/"+today+"/eu-central-1/s3/aws4_request,SignedHeaders=host;x-amz-content-sha256;x-amz-date;x-amz-security-token,Signature="+Signature;

            req.headers = req.headers || {};
            req.headers['Authorization'] = Authorization;
            req.headers['X-Amz-Security-token'] = credentials.sessionToken;
            req.headers['X-Amz-Date'] = now;
            req.headers['X-Amz-Content-Sha256'] = crypto.createHash('sha256').update('').digest('hex');

            return req;

        };

        var responseInterceptor = function (res) {
            if (res.status === 401 && req.url.indexOf(API_URL + '/api/auth/token') > -1) {
                $cookies.remove("loggedIn");
                return window.location = "/";
            }
            var tokenType = res.headers('X-Delivato-Token');
            console.log("res.token:", tokenType);
            console.log(res.data);
            if (tokenType) {
                if (tokenType == "accessToken") {
                    TokenLibrary.setLib(res.data);
                } else if (tokenType == "refreshToken") {
                    TokenLibrary.setRefreshToken(res.data);
                }

                if (res.data.redirectTo) window.location='/'+res.data.redirectTo;
            }

            return res;
        };

        return {
            request: requestInterceptor,
            response: responseInterceptor
        };

    }]);
